import mitt from "mitt";
import { router } from "@/route/index.js";
import useUserStore from "@/store/userStore.js";

// 创建事件总线实例
const emitter = mitt();

emitter.on("request:401", async () => {
  const userStore = useUserStore();
  userStore.cleanToken();
  await router.isReady();
  router.replace({
    name: "login",
  });
});

export default emitter;
